import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';
import { purple } from '@mui/material/colors';

type Props = ButtonProps & { active?: boolean };

export const SidebarButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'active',
})<Props>(({ theme, active }) => ({
  color: theme.palette.getContrastText(purple[100]),
  backgroundColor: active ? '#fff0f4' : 'none',
  borderRadius: '8px',
  textTransform: 'none',
  boxShadow: 'none',
  textAlign: 'left',
  alignItems: 'left',
  justifyContent: 'flex-start',
  padding: '8px',

  '&:hover': {
    backgroundColor: active ? '#ffdde5' : 'rgb(241, 245, 249)',
  },
}));
